
      (async () => {
        const settings = {};
        const config = (await import("https://shopify-gtm-suite.getelevar.com/configs/ade671bb7591dab837e869ca4b397fc743dcf885/config.js")).default;
        const scriptUrl = settings.proxyPath
          ? settings.proxyPath + config.script_src_custom_pages_proxied
          : config.script_src_custom_pages;

        if (scriptUrl) {
          const { handler } = await import(scriptUrl);
          await handler(config, settings);
        }
      })();
    